// extracted by mini-css-extract-plugin
export default {"root":"PlasmicAcceptedStatusCard_root__fi9rs","text":"PlasmicAcceptedStatusCard_text__CSzTe"};